import React from "react";
import { DELETE_USER, GET_USERS, UPDATE_USER } from "../../backend/graphql";
import {
  GraphQLDataGrid,
  GraphQLGridParameters,
} from "../widgets/GraphQLDataGrid";
import { RolesValues } from "../../app/features/auth/authTypes";
import { Stack } from "@mui/material";
import PageTitle from "../widgets/PageTitle";

const gridParameters: GraphQLGridParameters = {
  graphqlQuery: GET_USERS,
  graphqlItemsPath: (data) => data.users,
  graphqlUpdate: UPDATE_USER,
  graphqlUpdatePath: (data) => data.updateUser,
  graphqlAdd: UPDATE_USER,
  graphqlAddPath: (data) => data.updateUser,
  graphqlDelete: DELETE_USER,
  fields: [
    { field: "id", label: "ID", visible: false, width: 300, type: "uuid" },
    { field: "firstName", label: "First Name", editable: true },
    {
      field: "lastName",
      label: "Last Name",
      defaultSort: "asc",
      editable: true,
    },
    { field: "eMail", label: "E-mail", editable: true },
    {
      field: "role",
      label: "Role",
      editable: true,
      width: 120,
      type: "singleSelect",
      valueOptions: [...RolesValues],
    },
    {
      field: "isDeveloper",
      label: "Is developer",
      type: "boolean",
      visible: false,
      width: 110,
    },
    { field: "lastLogin", label: "Last Login", type: "dateTimeShort" },
  ],
};

const Users = () => {
  return (
    <Stack spacing={1} useFlexGap>
      <PageTitle />
      <GraphQLDataGrid parameters={gridParameters} elevated />
    </Stack>
  );
};

export default Users;
